import { useEffect, useState, useRef, useContext } from 'react';
import {
    Input,
    Button,
    Pagination,
    Empty,
    Dropdown,
    Modal,
    message,
    Menu,
    Checkbox,
} from 'antd';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { useStoreState } from '&/utils/customHooks';
import BasePageWrap from '&/components/ResourceLib/BasePageWrap';
import emptyIcon from '&/assets/img/userCenter/emptyydata-object.png';
import DecorationCard4B from '&/components/ProjectSpace/DecorationCard4B';
import warningIcon from '&/assets/img/userCenter/warnimg.png';
import BuyService from '&/components/ProjectSpace/BuyService';
import EditScheme from '&/pages/user-center/EditScheme';
import LabelFilter from '&/components/ProjectSpace/LabelFilter';
import DateRange from '&/components/DateRange';
import { getDecorationList, schemeBatchOperation } from '@/api/Decoration';
import { LoadingContext } from '&/components/LoadingComponent';
import { getDesignStyle } from '&/api/home';
import enterpriseMemberIcon from '&/assets/img/member/enterpriseMemberIcon.png';
import './DecorationScheme.scss';

function DecorationScheme() {
    const [schemeList, setSchemeList] = useState([]);
    const [queryForm, setQueryForm] = useState({
        sort: +localStorage.getItem('schemeDateSortType') || 1,
        page: 1,
        pageNum: 12,
        cliqueType: -1,
    });
    const [gratisProjectNum, setGratisProjectNum] = useState(0);
    const [mySchemeNum, setMySchemeNum] = useState(0);
    const [collaborationSchemeNum, setCollaborationSchemeNum] = useState(0);
    const [visible, setVisible] = useState(false);
    const [formData, setFormData] = useState({});
    const [visible1, setVisible1] = useState(false);
    const [active, setActive] = useState(0);
    const [batchVisible, setBatchVisible] = useState(false);
    const [selectNumber, setSelectNumber] = useState(0);
    const [selectList, setSelectList] = useState([]);
    const [styleList, setStyleList] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [batchParams, setBatchParams] = useState({
        dap: 1,
        schemeIds: [],
    });

    const appStore = useStoreState('appStore'),
        isAdmin = appStore.organization?.roleFlag === 'admin';

    const { vipEntExpireFlag, vipEntType } = appStore.userInfo;
    const notEntMembership =
        vipEntType !== 'vip_ent_unite' || vipEntExpireFlag !== 0;

    const detail = useRef();

    const loadingContext = useContext(LoadingContext);

    const tabs = [
        {
            name: intl.get('decorationScheme.tabs.myScheme', {
                value: mySchemeNum,
            }),
            index: 0,
            isShow: true,
        },
        {
            name: intl.get('decorationScheme.tabs.collaborationScheme', {
                value: collaborationSchemeNum,
            }),
            index: 1,
            isShow:
                process.env.REACT_APP_ENV_TAG === 'dev' ||
                process.env.REACT_APP_ENV_TAG === 'local',
        },
    ];

    const menuProps = [
        {
            id: 'edit',
            label: intl.get('decorationScheme.menu.edit'),
        },
        {
            id: 'create',
            label: intl.get('decorationScheme.menu.create'),
        },
        {
            id: 'publish',
            label: intl.get('decorationScheme.menu.publish'),
        },
        {
            id: 'collaboration',
            label: intl.get('decorationScheme.menu.startCollaboration'),
        },
        {
            id: 'gotoCollaboration',
            label: intl.get('decorationScheme.menu.gotoCollaboration'),
        },
        {
            id: 'delete',
            label: intl.get('decorationScheme.menu.delete'),
        },
    ];

    const collaborationMenuProps = [
        {
            id: 'dissolveCollaboration',
            label: intl.get('decorationScheme.menu.dissolveCollaboration'),
        },
        {
            id: 'exitCollaboration',
            label: intl.get('decorationScheme.menu.exitCollaboration'),
        },
    ];

    const sortMenuProps = [
        {
            label: intl.get('decorationScheme.sortType.reverseUpdateTimeOrder'),
            key: 3,
        },
        {
            label: intl.get('decorationScheme.sortType.updateTimeOrder'),
            key: 4,
        },
        {
            label: intl.get('decorationScheme.sortType.reverseCreateTimeOrder'),
            key: 1,
        },
        {
            label: intl.get('decorationScheme.sortType.createTimeOrder'),
            key: 2,
        },
    ];

    const history = useHistory();

    useEffect(() => {
        getDesignStyle({ entId: undefined }).then(({ data }) => {
            setStyleList(data);
            // const tags = data.map(e => ({ value: e.id, label: e.name }));
        });
    }, []);

    useEffect(() => {
        if (queryForm.cliqueType === -1) return;
        loadingContext.toggleSpin();
        getDecorationList(queryForm)
            .then(res => {
                if (res.data && res.code === 0 && res.data.list) {
                    setSchemeList(res.data.list);
                    setGratisProjectNum(res.data.gratisProjectNum);
                    if (+active === 0) {
                        setMySchemeNum(res.data.page.totalList);
                    } else {
                        setCollaborationSchemeNum(res.data.page.totalList);
                    }
                }
            })
            .finally(loadingContext.toggleSpin);
    }, [queryForm]);

    useEffect(() => {
        if (batchParams.schemeIds.length > 0) {
            loadingContext.toggleSpin();
            schemeBatchOperation(batchParams)
                .then(res => {
                    if (res.code === 0) {
                        setBatchParams({ dap: 1, schemeIds: [] });
                        setSelectList([]);
                        setBatchVisible(false);
                        setQueryForm({ ...queryForm, page: 1 });
                        document
                            .querySelectorAll('.scheme-list-wrap')
                            ?.forEach(item => item.classList.remove('select'));

                        if (+batchParams.dap === 2) {
                            message.success({
                                content: intl.get(
                                    'decorationScheme.publishConfirm.feedback'
                                ),
                            });
                        }
                    }
                })
                .finally(() => {
                    loadingContext.toggleSpin();
                });
        }
    }, [batchParams]);

    useEffect(() => {
        if (+active === 0) {
            setQueryForm(value => ({
                ...value,
                page: queryForm.page,
                pageNum: queryForm.pageNum,
                cliqueType: 1,
                myCollaborative: null,
                isCollaborative: null,
            }));
            getDecorationList({
                page: 1,
                pageNum: 1,
                cliqueType: 1,
                myCollaborative: 1,
                isCollaborative: 1,
            }).then(res => {
                if (res.data.page && res.data.page.totalList) {
                    setCollaborationSchemeNum(res.data.page.totalList);
                }
            });
        } else {
            setQueryForm(value => ({
                ...value,
                page: queryForm.page,
                pageNum: queryForm.pageNum,
                cliqueType: 1,
                myCollaborative: 1,
                isCollaborative: 1,
            }));
            getDecorationList({ page: 1, pageNum: 1, cliqueType: 1 }).then(
                res => {
                    if (res.data.page && res.data.page.totalList) {
                        setMySchemeNum(res.data.page.totalList);
                    }
                }
            );
        }
    }, [active]);

    useEffect(() => {
        setSelectNumber(selectList.length);
    }, [selectList]);

    const onTabChange = (current, idx) => {
        setActive(idx);
    };

    const onSelectSort = e => {
        localStorage.setItem('schemeDateSortType', e.key);
        setQueryForm({ ...queryForm, sort: e.key });
    };

    const sortMenu = (
        <Menu onClick={onSelectSort}>
            {sortMenuProps.map(el => (
                <Menu.Item key={el.key}>{el.label}</Menu.Item>
            ))}
        </Menu>
    );

    const go2Detail = scheme => {
        !batchVisible &&
            history.push(
                `/user-center/decoration-scheme/decoration-design/${scheme.id}`
            );
    };

    const WARN_ICON = (
        <img src={warningIcon} alt="warning" className="confirm-icon" />
    );

    const createProject = value => {
        setFormData({
            ...value,
            id: '',
            schemeId: value.id,
            name: value.title,
            createName: appStore.userInfo.username,
            createWithInit: true,
        });
        setVisible1(true);
    };

    const methods = {
        create: createProject,
        edit(scheme) {
            setVisible(true);
            detail.current = scheme;
        },
        delete(scheme) {
            deleteBatchHandler([scheme.id]);
        },
        publish(scheme) {
            publishedBatchHandler([scheme.id]);
        },
        collaboration() {},
    };

    const clickMenuHandler = ({ key }, item) => {
        methods[key](item);
    };

    const changeSelectHandler = event => {
        const schemeItem = event.target.closest('.scheme-list-wrap');
        if (batchVisible) {
            if (schemeItem && schemeItem.classList.contains('select')) {
                schemeItem.classList.remove('select');
                setSelectList(
                    selectList.filter(item => item !== schemeItem.id)
                );
            } else if (schemeItem) {
                schemeItem.classList.add('select');
                setSelectList([...selectList, schemeItem.id]);
            }
        } else {
            const moreIcon = event.target.closest('.get-more-icon');
            if (moreIcon) return;
            if (schemeItem) {
                go2Detail(schemeItem);
            }
        }
    };

    const changeSelectAllHandler = event => {
        const { checked } = event.target;
        if (checked) {
            setSelectList(schemeList.map(item => item.id));
            document
                .querySelectorAll('.scheme-list-wrap')
                ?.forEach(item => item.classList.add('select'));
        } else {
            setSelectList([]);
            document
                .querySelectorAll('.scheme-list-wrap')
                ?.forEach(item => item.classList.remove('select'));
        }
    };

    const cancelBatchHandler = () => {
        setBatchVisible(false);
        document
            .querySelectorAll('.scheme-list-wrap')
            ?.forEach(item => item.classList.remove('select'));
        setSelectList([]);
    };

    const handlePageChange = params => {
        setQueryForm(value => ({
            ...value,
            page: params,
        }));
    };

    const onLabelFilterChange = filterList => {
        const params = {};
        if (filterList.value) {
            const { value } = filterList;
            if (value.area) {
                params.inner = value.area.map(item => item?.split('-'));
            }
            if (value.houseType) {
                params.houseNum = value.houseType;
            }
            if (value.style) {
                params.form = value.style;
            }
        }
        setQueryForm(value => ({
            ...value,
            ...params,
        }));
    };

    const filterNameHandler = () => {
        setQueryForm(val => ({
            ...val,
            keyword: searchValue,
        }));
    };

    const changeDateHandler = value => {
        setQueryForm(val => ({
            ...val,
            date: value ? value.map(item => item.unix()) : null,
        }));
    };

    const publishedBatchHandler = schemeIds => {
        if (!schemeIds || schemeIds.length === 0) return;
        const filterList = schemeIds.filter(id => {
            return schemeList.some(
                schemeItem =>
                    schemeItem.id === id && +schemeItem.hasSyncScheme !== 1
            );
        });
        if (filterList.length === 0) {
            cancelBatchHandler();
            return;
        }
        Modal.confirm({
            width: 350,
            className: 'confirm-modal',
            title: intl.get('decorationScheme.publishConfirm.title'),
            icon: WARN_ICON,
            content: intl.get('decorationScheme.publishConfirm.description'),
            okText: intl.get('decorationScheme.publishConfirm.confirm'),
            cancelText: intl.get('decorationScheme.publishConfirm.cancel'),
            onOk: async () => {
                setBatchParams({
                    dap: 2,
                    schemeIds: filterList,
                });
            },
            centered: true,
        });
    };

    const deleteBatchHandler = schemeIds => {
        Modal.confirm({
            width: 350,
            className: 'confirm-modal',
            title: intl.get('decorationScheme.deleteConfirm.title'),
            icon: WARN_ICON,
            content: intl.get('decorationScheme.deleteConfirm.description'),
            okText: intl.get('decorationScheme.deleteConfirm.confirm'),
            cancelText: intl.get('decorationScheme.deleteConfirm.cancel'),
            onOk: async () => {
                setBatchParams({
                    dap: 3,
                    schemeIds,
                });
            },
            centered: true,
        });
    };

    const renderMenuProps = item => {
        const menu = [menuProps, collaborationMenuProps][active].filter(
            prop => {
                if (+active === 0) {
                    if (+item.hasProject === 1 && prop.id === 'create') {
                        return false;
                    }
                    if (+item.hasSyncScheme === 1 && prop.id === 'publish') {
                        return false;
                    }
                    if (
                        prop.id === 'collaboration' &&
                        (+item.isCollaborative === 1 ||
                            (process.env.REACT_APP_ENV_TAG !== 'dev' &&
                                process.env.REACT_APP_ENV_TAG !== 'local'))
                    ) {
                        return false;
                    }
                    if (
                        prop.id === 'gotoCollaboration' &&
                        (+item.isCollaborative === 0 ||
                            (process.env.REACT_APP_ENV_TAG !== 'dev' &&
                                process.env.REACT_APP_ENV_TAG !== 'local'))
                    ) {
                        return false;
                    }
                    return true;
                } else {
                    return true;
                }
            }
        );
        return (
            (active === 0 || isAdmin) && (
                <Menu
                    className="scheme__card-dropdown"
                    onClick={e => clickMenuHandler(e, item)}>
                    {menu.map(menuItem => {
                        const intercept =
                            ['collaboration', 'publish'].includes(
                                menuItem.id
                            ) && notEntMembership;

                        return (
                            <Menu.Item disabled={intercept} key={menuItem.id}>
                                {menuItem.label}
                                {intercept && (
                                    <img
                                        className="ent-icon"
                                        src={enterpriseMemberIcon}
                                        alt=""
                                    />
                                )}
                            </Menu.Item>
                        );
                    })}
                </Menu>
            )
        );
    };

    const batchBtnClickHandler = () => {
        if (schemeList.length > 0) {
            setBatchVisible(true);
        }
    };

    return (
        <>
            <BasePageWrap
                className="decoration-scheme"
                type="card"
                tabs={tabs.filter(tab => tab.isShow)}
                onTabChange={onTabChange}>
                <div className="params-wrap">
                    <div className="left-content-wrap">
                        <LabelFilter
                            area={queryForm.inner?.map(item => item.join('-'))}
                            houseType={queryForm.houseNum}
                            houseStyle={queryForm.form}
                            houseTypeList={styleList}
                            onConfirmFilterHandler={onLabelFilterChange}
                        />
                        <DateRange
                            onChange={changeDateHandler}
                            value={queryForm.date?.map(date =>
                                moment.unix(date)
                            )}
                        />
                        <Dropdown overlay={sortMenu} trigger={['click']}>
                            <span>
                                {
                                    sortMenuProps.find(
                                        el => +el.key === +queryForm.sort
                                    )?.label
                                }
                                <i className="outlined sort-icon" />
                            </span>
                        </Dropdown>
                    </div>
                    <div className="right-content-wrap">
                        <Input
                            className="label-name"
                            placeholder={intl.get(
                                'decorationScheme.label.name'
                            )}
                            size="small"
                            suffix={
                                <i
                                    className="icon-search filled pointer"
                                    style={{ fontSize: '0.75rem' }}
                                    onClick={filterNameHandler}
                                />
                            }
                            value={searchValue}
                            onChange={e => setSearchValue(e.target.value)}
                            onPressEnter={filterNameHandler}
                            allowClear
                        />
                        <div className="divider" />
                        {batchVisible ? (
                            <div>
                                <Checkbox
                                    disabled={schemeList.length === 0}
                                    className="batch-operation-btn"
                                    checked={
                                        selectList.length > 0 &&
                                        selectList.length === schemeList.length
                                    }
                                    indeterminate={
                                        selectList.length > 0 &&
                                        selectList.length !== schemeList.length
                                    }
                                    onChange={changeSelectAllHandler}>
                                    {intl.get(
                                        'decorationScheme.alreadySelect',
                                        { value: selectNumber }
                                    )}
                                </Checkbox>
                                <Button
                                    className="batch-operation-btn"
                                    onClick={() =>
                                        publishedBatchHandler(selectList)
                                    }>
                                    {intl.get('decorationScheme.menu.publish')}
                                </Button>
                                <Button
                                    className="batch-operation-btn"
                                    onClick={() =>
                                        deleteBatchHandler(selectList)
                                    }>
                                    {intl.get('base.delete')}
                                </Button>
                                <Button
                                    className="batch-operation-btn"
                                    onClick={cancelBatchHandler}>
                                    {intl.get('base.cancel')}
                                </Button>
                            </div>
                        ) : (
                            <Button
                                disabled={schemeList.length === 0}
                                className="batch-operation-btn"
                                onClick={batchBtnClickHandler}>
                                {intl.get('decorationScheme.batchOperation')}
                            </Button>
                        )}
                    </div>
                </div>
                {schemeList.length === 0 ? (
                    <Empty
                        image={emptyIcon}
                        imageStyle={{
                            height: 160,
                            marginTop: '10%',
                        }}
                        description={
                            <div className="hint-message">
                                {intl.get('decorationScheme.empty')}
                            </div>
                        }
                    />
                ) : (
                    <div className="decoration-scheme-list-wrap">
                        {schemeList.map(item => (
                            <div
                                className="scheme-list-wrap"
                                key={item.id}
                                id={item.id}
                                onClick={changeSelectHandler}>
                                {batchVisible && (
                                    <Checkbox
                                        checked={selectList.some(
                                            select => select === item.id
                                        )}
                                        className="scheme-item-checkbox"
                                    />
                                )}
                                <DecorationCard4B
                                    className="scheme-item"
                                    value={item}
                                    buttonDisabled={batchVisible}
                                    go2Detail={go2Detail}
                                    menuRender={() => renderMenuProps(item)}
                                />
                            </div>
                        ))}
                    </div>
                )}
                <EditScheme
                    detailData={detail.current}
                    visible={visible}
                    setVisible={setVisible}
                    styleList={styleList}
                    submitCb={() => {
                        setQueryForm({ ...queryForm, page: 1 });
                    }}
                />

                {visible1 && (
                    <BuyService
                        visible={visible1}
                        initData={formData}
                        div={3}
                        initState={'form'}
                        setVisible={setVisible1}
                        gratisProjectNum={gratisProjectNum}
                        refesh={() => {
                            setQueryForm({ ...queryForm, page: 1 });
                        }}
                    />
                )}
                <Pagination
                    size="small"
                    current={queryForm.page}
                    onChange={handlePageChange}
                    total={[mySchemeNum][+active]}
                    pageSize={queryForm.pageNum}
                    showTotal={total => intl.get('base.total', { total })}
                />
            </BasePageWrap>
        </>
    );
}

export default DecorationScheme;
